import React from 'react'
import { Link } from 'react-router-dom'

import { FaHandHolding } from 'react-icons/fa'

const Home = () => {    
    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Theatre</h2>
                    <span className="flex items-center justify-between">
                        <Link className="ml-2" to={ `/app/theatre/requests` }>
                            <button className="btn hisani-btn-green-light text-white flex items-center justify-between">
                                <FaHandHolding />
                                <span className="xs:block ml-2">Requests</span>
                            </button>
                        </Link>
                    </span>
                </header>
            </div>
        </div>
    )
}

export default Home